import { vases } from '../data/vases';

export type ModelViewerOption = {
  value: string;
  label: string;
  posterSrc: string;
  vaseId?: number;
};

export const MODEL_VIEWER_OPTIONS: ModelViewerOption[] = vases
  .filter(
    (vase): vase is typeof vase & { modelPath: string; image: string } =>
      typeof vase.modelPath === 'string' &&
      vase.modelPath.trim().length > 0 &&
      typeof vase.image === 'string' &&
      vase.image.trim().length > 0
  )
  .map((vase) => ({
    value: vase.modelPath,
    label: vase.name,
    posterSrc: vase.image,
    vaseId: vase.id,
  }));

export const DEFAULT_MODEL_VIEWER_OPTION = MODEL_VIEWER_OPTIONS[0] ?? null;

export function findModelViewerOption(modelPath: unknown): ModelViewerOption | null {
  if (typeof modelPath !== 'string' || modelPath.trim().length === 0) return null;
  return MODEL_VIEWER_OPTIONS.find((option) => option.value === modelPath) ?? null;
}

export function findModelViewerOptionByReference(options: {
  vaseId?: unknown;
  modelPath?: unknown;
}): ModelViewerOption | null {
  if (Number.isFinite(options.vaseId) && Number(options.vaseId) > 0) {
    const byVaseId = MODEL_VIEWER_OPTIONS.find((option) => option.vaseId === Number(options.vaseId));
    if (byVaseId) return byVaseId;
  }

  return findModelViewerOption(options.modelPath);
}
